import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ReactiveFormsModule } from "@angular/forms";
import { LoginGuard } from "../auth/loginGuard";
import { PhysicianLayoutComponent } from "./layout/physician-layout.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { PracticeProfileComponent } from "./profile/practice/practice-profile.component";
import { PracticeProfilesComponent } from "./profile/practice/practice-profiles/practice-profiles.component";
import { SigninComponent } from "./signin/signin.component";
import { ComingSoonComponent } from "../physician/coming-soon/coming-soon.component";
import { SetupSummaryComponent } from "./setup/setup-summary/setup-summary/setup-summary.component";
import { SetupPracticeComponent } from "./setup/setup-practice/setup-practice.component";
import { PhysicianFavoritesComponent } from "./favorites/physician-favorites/physician-favorites.component";
import { SetupCheckoutComponent } from "./setup/setup-checkout/setup-checkout.component";
import { SetupCompleteComponent } from "./setup/setup-checkout/setup-complete.component";
import { InactiveUserComponent } from "./InactiveUser/InactiveUser.component";
import { PhysicianLayoutWithoutSelectorComponent } from "./layout/physician-layout-without-selector.Component";
import { SetupPaymentMethodComponent } from "./setup/setup-payment-method/setup-payment-method.component";
import { PaymentsListComponent } from "./setup/payments-list/payments-list.component";
import { ListSearchFormsComponent } from "./formdocs/list-search-forms/list-search-forms.component";
import { FormDocumentDetailsComponent } from "./formdocs/form-document-details/form-document-details.component";
import { SetupOrganizationComponent } from "./setup/setup-organization/setup-organization.component";
import { FormTemplateDetailsComponent } from "./formdocs/form-template-details/form-template-details.component";
import { ChatComponent } from "./chat/chat.component";
import { FormAcroformdesignComponent } from "./formdocs/form-acroformdesign/form-acroformdesign.component";
import { DiscoverComponent } from "./discover/discover.component";
import { SubscriptionComponent } from "./subscription/subscription/subscription.component";
import { SettingsComponent } from "./settings/settings.component";
import { FindCareComponent } from "../shared/components/find-care/find-care.component";
import { FindCareTeamComponent } from "../shared/components/find-care/find-care-team/find-care-team.component";

const routes: Routes = [
  {
    path: "inactive",
    component: PhysicianLayoutWithoutSelectorComponent,
    children: [
      { path: "", component: InactiveUserComponent, canActivate: [LoginGuard] },
    ],
  },
  {
    path: "physician",
    component: PhysicianLayoutComponent,
    children: [
    
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
      { path: "profile/signIn", component: SigninComponent },
      { path: "comingsoon", component: ComingSoonComponent },
      {
        path: 'findcare',
        component: FindCareComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'findcare/:categoryId',
        component: FindCareComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'team/findcare',
        component: FindCareTeamComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "favorites",
        component: PhysicianFavoritesComponent,
        canActivate: [LoginGuard],
      },
      { path: "messages", component: ChatComponent, canActivate: [LoginGuard] },
      {
        path: "patients",
        loadChildren: "../patients/patients.module#PatientsModule",
      },
      {
        path: "practitioners",
        loadChildren:
          "../practitioners/practitioners.module#PractitionersModule",
      },      
      {
        path: "referrals",
        loadChildren: "../referrals/referrals.module#ReferralsModule",
      },
      { path: "events", loadChildren: "../events/events.module#EventsModule" },
      {
        path: 'marketplace',
        loadChildren: "../market-place/market-place.module#MarketPlaceModule",
      },
      {
        path: "appointments",
        loadChildren: "./appointments/appointments.module#AppointmentsModule",
      },
      {
        path: "physicianPatient",
        loadChildren: "./patient/patient-search.module#PatientSearchModule",
      },
      {
        path: "searchReferral",
        loadChildren: "./referral/referral-search.module#ReferralSearchModule",
      }, 
      {
        path: "discover",
        component: DiscoverComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "subscription",
        component: SubscriptionComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "settings",
        component: SettingsComponent,
        canActivate: [LoginGuard],
      },
    ],
  },
  {
    path: "physician/forms",
    component: PhysicianLayoutWithoutSelectorComponent,
    children: [
      {
        path: "",
        component: ListSearchFormsComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "details/:id",
        component: FormDocumentDetailsComponent, //FormDocumentDetailsComponent,//FormAcroformdesignComponent,//
        canActivate: [LoginGuard],
      },
      {
        path: "templateDetails/:id",
        component: FormTemplateDetailsComponent,
        canActivate: [LoginGuard],
      },
    ],
  },
  {
    path: "physician/profile",
    component: PhysicianLayoutWithoutSelectorComponent,
    children: [
      {
        path: "summary",
        component: SetupSummaryComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "setup",
        component: SetupPracticeComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "setupOrganization",
        component: SetupOrganizationComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "setupCheckout",
        component: SetupCheckoutComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "setupCompleted",
        component: SetupCompleteComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "setupPaymetMethod",
        component: SetupPaymentMethodComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "payments",
        component: PaymentsListComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "",
        loadChildren:
          "./profile/physician/physician-profile.module#PhysicianProfileModule",
        canActivate: [LoginGuard],
      },
    ],
  },
  {
    path: "practice",
    component: PhysicianLayoutComponent,
    children: [
      {
        path: "profile",
        loadChildren:
          "./profile/physician/physician-profile.module#PhysicianProfileModule",
        canActivate: [LoginGuard],
      },
      //{ path: "profile", component: PracticeProfileComponent },
      //{ path: "profile/:id", component: PracticeProfileComponent },
      { path: "profile/edit", component: PracticeProfileComponent },
      { path: "profiles", component: PracticeProfilesComponent },
      { path: "profile/setup", component: SetupSummaryComponent },
    ],
  }
  
];

@NgModule({
  declarations: [],
  imports: [ReactiveFormsModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PhysicianRoutingModule { }
